import { Component, HostListener, Input } from "@angular/core";
import { CitiShopPropsService } from "../../utility/citi-shop-props.service";
import { MktTaggingTransformationService } from "src/app/core/services";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-citi-shop-mobile-instructions",
  templateUrl: "./citi-shop-mobile-instructions.component.html",
  styleUrls: ["./citi-shop-mobile-instructions.component.scss"],
  standalone: false
})
export class CitiShopMobileInstructionsComponent {
  content: any;
  backgroundImage: any;
  displayChromeMsg: boolean;
  displayEnrollmentBtn: boolean = false;
  @Input() contentMobile: any = '{}';

  constructor(public csp: CitiShopPropsService,
    private _mktTaggingTransformationService: MktTaggingTransformationService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.content = this.contentMobile;
    if (
      this.csp.browserName().toLowerCase() === "chrome" ||
      this.csp.browserName() === "Unknown"
    ) {
      this.displayChromeMsg = true;
    } else {
      this.displayChromeMsg = false;
    }

    if (this.content.showCopyEnrollmentLinkBtn === "true") {
      this.displayEnrollmentBtn = true;
    }
    this.onWindowResize();
  }

  @HostListener("window.resize", ["$event"])
  private onWindowResize() {
    if (!this.csp.isBrowser()) return;
    const windowWidth = window ? window.innerWidth : 0;
    if (windowWidth <= 600) {
      this.backgroundImage = this.csp.imagePrefix() + this.content.mobileImage;
    } else {
      this.backgroundImage =
        this.csp.imagePrefix() + this.content.instructionsBackgroundImage;
    }
  }


  onTaggingCall(event: any): void {
    const pageTypeToTaggingEventName = {
      'ioschrome': '641_b2_CitiShop_PreLogin_Instructions_ioschrome_CTAClicked',
      'iosedge': '641_d2_CitiShop_PreLogin_Instructions_iosedge_CTAClicked',
      'androidchrome': '641_e2_CitiShop_PreLogin_Instructions_androidchrome_CTAClicked',
      'androidedge': '641_f2_CitiShop_PreLogin_Instructions_androidedge_CTAClicked'
    };

    const taggingEventName = pageTypeToTaggingEventName[this.route.snapshot.params.pageType];

    if (taggingEventName) {
      this._mktTaggingTransformationService.triggerEventTagging('nonicms_content', taggingEventName);
    }

    if (event.currentTarget.type === 'button') this.copyEnrollmentLink();
  }

  copyEnrollmentLink() {
    const instance = setTimeout(() => {
      clearTimeout(instance);
      const link = this.content.enrollmentLink;
      window.navigator.clipboard.writeText(link).then(_=> console.log('link event triggered!!!')).catch(_=> console.log('failed to triggred event !!!'));
    }, 0);
  }
}
